export const SET_BILLING_LIST = 'SET_BILLING_LIST';
export const SET_BILLING_OPTION_ID = 'SET_BILLING_OPTION_ID';
export const SET_BILLING_OPTION = 'SET_BILLING_OPTION';
export const SET_BILLING_INVOICES = 'SET_BILLING_INVOICES';


// WEBPACK FOOTER //
// ./src/store/modules/billing-info/mutations.js